import * as React from 'react';
import { SVGProps } from 'react';

export interface IcVideocallProps extends SVGProps<SVGSVGElement> {
  bg?: string;
}

const IcVideocall = ({ bg, ...props }: IcVideocallProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={bg || '#8357CD'}
      fillRule="evenodd"
      d="M12 1.5C6.2 1.5 1.5 6.2 1.5 12S6.2 22.5 12 22.5 22.5 17.8 22.5 12 17.8 1.5 12 1.5Z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      d="M5.5 8.667c0-.442.184-.866.513-1.179A1.795 1.795 0 0 1 7.25 7h5.25c.464 0 .91.176 1.237.488.329.313.513.737.513 1.179v6.666c0 .442-.184.866-.513 1.179A1.795 1.795 0 0 1 12.5 17H7.25c-.464 0-.91-.176-1.237-.488a1.627 1.627 0 0 1-.513-1.179V8.667Zm10.984.921a.86.86 0 0 0-.353.307.804.804 0 0 0-.131.438v3.334c0 .154.045.306.13.438a.86.86 0 0 0 .354.307l1.75.833a.911.911 0 0 0 .85-.036.852.852 0 0 0 .305-.303.803.803 0 0 0 .111-.406v-5a.803.803 0 0 0-.11-.406.853.853 0 0 0-.305-.303.906.906 0 0 0-.851-.036l-1.75.833Z"
    />
  </svg>
);
export default IcVideocall;
